const actions = {
  CREATE_QRCODE_BEGIN: "CREATE_QRCODE_BEGIN",
  CREATE_QRCODE_SUCCESS: "CREATE_QRCODE_SUCCESS",
  CREATE_QRCODE_ERR: "CREATE_QRCODE_ERR",

  LIST_QRCODES_BEGIN: "LIST_QRCODES_BEGIN",
  LIST_QRCODES_SUCCESS: "LIST_QRCODES_SUCCESS",
  LIST_QRCODES_ERR: "LIST_QRCODES_ERR",

  UPDATE_QRCODE_BEGIN: "UPDATE_QRCODE_BEGIN",
  UPDATE_QRCODE_SUCCESS: "UPDATE_QRCODE_SUCCESS",
  UPDATE_QRCODE_ERR: "UPDATE_QRCODE_ERR",

  DELETE_QRCODE_BEGIN: "DELETE_QRCODE_BEGIN",
  DELETE_QRCODE_SUCCESS: "DELETE_QRCODE_SUCCESS",
  DELETE_QRCODE_ERR: "DELETE_QRCODE_ERR",

  BLOCK_QRCODE_BEGIN: "BLOCK_QRCODE_BEGIN",
  BLOCK_QRCODE_SUCCESS: "BLOCK_QRCODE_SUCCESS",
  BLOCK_QRCODE_ERR: "BLOCK_QRCODE_ERR",

  UNBLOCK_QRCODE_BEGIN: "UNBLOCK_QRCODE_BEGIN",
  UNBLOCK_QRCODE_SUCCESS: "UNBLOCK_QRCODE_SUCCESS",
  UNBLOCK_QRCODE_ERR: "UNBLOCK_QRCODE_ERR",

  GET_QRCODE_DETAILS_BEGIN: "GET_QRCODE_DETAILS_BEGIN",
  GET_QRCODE_DETAILS_SUCCESS: "GET_QRCODE_DETAILS_SUCCESS",
  GET_QRCODE_DETAILS_ERR: "GET_QRCODE_DETAILS_ERR",

  createQRCodeBegin: () => {
    return {
      type: actions.CREATE_QRCODE_BEGIN,
    };
  },

  createQRCodeSuccess: (data) => {
    return {
      type: actions.CREATE_QRCODE_SUCCESS,
      data,
    };
  },

  createQRCodeErr: (err) => {
    return {
      type: actions.CREATE_QRCODE_ERR,
      err,
    };
  },

  listQRCodesBegin: () => {
    return {
      type: actions.LIST_QRCODES_BEGIN,
    };
  },

  listQRCodesSuccess: (data) => {
    return {
      type: actions.LIST_QRCODES_SUCCESS,
      data,
    };
  },

  listQRCodesErr: (err) => {
    return {
      type: actions.LIST_QRCODES_ERR,
      err,
    };
  },

  updateQRCodeBegin: () => {
    return {
      type: actions.UPDATE_QRCODE_BEGIN,
    };
  },

  updateQRCodeSuccess: (data) => {
    return {
      type: actions.UPDATE_QRCODE_SUCCESS,
      data,
    };
  },

  updateQRCodeErr: (err) => {
    return {
      type: actions.UPDATE_QRCODE_ERR,
      err,
    };
  },

  deleteQRCodeBegin: () => {
    return {
      type: actions.DELETE_QRCODE_BEGIN,
    };
  },

  deleteQRCodeSuccess: (data) => {
    return {
      type: actions.DELETE_QRCODE_SUCCESS,
      data,
    };
  },

  deleteQRCodeErr: (err) => {
    return {
      type: actions.DELETE_QRCODE_ERR,
      err,
    };
  },

  blockQRCodeBegin: () => {
    return {
      type: actions.BLOCK_QRCODE_BEGIN,
    };
  },

  blockQRCodeSuccess: (data) => {
    return {
      type: actions.BLOCK_QRCODE_SUCCESS,
      data,
    };
  },

  blockQRCodeErr: (err) => {
    return {
      type: actions.BLOCK_QRCODE_ERR,
      err,
    };
  },

  unblockQRCodeBegin: () => {
    return {
      type: actions.UNBLOCK_QRCODE_BEGIN,
    };
  },

  unblockQRCodeSuccess: (data) => {
    return {
      type: actions.UNBLOCK_QRCODE_SUCCESS,
      data,
    };
  },

  unblockQRCodeErr: (err) => {
    return {
      type: actions.UNBLOCK_QRCODE_ERR,
      err,
    };
  },

  getQRCodeDetailsBegin: () => {
    return {
      type: actions.GET_QRCODE_DETAILS_BEGIN,
    };
  },

  getQRCodeDetailsSuccess: (data) => {
    return {
      type: actions.GET_QRCODE_DETAILS_SUCCESS,
      data,
    };
  },

  getQRCodeDetailsErr: (err) => {
    return {
      type: actions.GET_QRCODE_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
